import React, { Component } from 'react';
import { connect } from 'react-redux';
import { soporteObtenerPreguntasKnowledgeBase } from '../../../store/actions';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Icon,
  Typography,
  withStyles,
  LinearProgress,
} from '@material-ui/core';
import parse from 'html-react-parser';
import { ButtonUI, AlertUI } from '../../common';
import { WrapperLayout } from '../../../layouts/WrapperLayout';

const HtmlDecode = ({ input }) => {
  input = input.split('<p><br></p>').join('<br>');
  input = input.split('<br><br>').join('<br>');
  if (input.slice(-4) === '<br>') {
    input = input.slice(0, -4);
  }
  return parse('<div class="ql-container">' + input + '</div>');
};

class ArticuloDetail_ extends Component {
  state = {
    loading: {
      articulo: true,
      error: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
    articulo: [],
  };

  componentDidMount() {
    let slugs = this.props.location.pathname.split('/');
    let article_slug = slugs[slugs.length - 1];
    let subcategory_slug = slugs[slugs.length - 2];
    let category_slug = slugs[slugs.length - 3];
    this.props.soporteObtenerPreguntasKnowledgeBase((err, resp) => {
      let category = resp.data.knowledge_base_data.filter(
        (category_item) => category_item.slug === category_slug
      );
      let subcategory = category[0].subcategories.filter(
        (subcategory_item) => subcategory_item.slug === subcategory_slug
      );
      let articulo = subcategory[0].articles.filter(
        (articulo_item) => articulo_item.slug === article_slug
      );

      this.setState({
        loading: {
          ...this.state.loading,
          articulo: false,
          error: err ? true : false,
        },
        articulo: articulo,
      });
    });
  }

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  render() {
    let classes = this.props.classes;

    let articulo = this.state.articulo;

    return (
      <WrapperLayout
        loading={this.state.loading.articulo}
        error={this.state.loading.error}
      >
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Grid container spacing={16} alignItems="center">
              <Grid item>
                <ButtonUI
                  label={<Icon>keyboard_arrow_left</Icon>}
                  type="callf"
                  onClickFunc={() => (window.location.href = '/soporte')}
                />
              </Grid>
              <Grid item>
                <Typography className={classes.title_back}>
                  Volver a preguntas frecuentes
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {this.state.loading.articulo || !articulo[0] ? (
          <CardContent className={classes.card_content}>
            <LinearProgress />
          </CardContent>
        ) : (
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Card className={classes.card_below}>
                <CardHeader
                  title={articulo[0].title}
                  classes={{ title: classes.card_header }}
                />
                <Divider />
                <CardContent className={classes.card_content}>
                  <div className={classes.wrapper}>
                    <HtmlDecode input={articulo[0].content} />
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </WrapperLayout>
    );
  }
}

const styles = (theme) => ({
  card_below: theme.card.card_below,
  card_content: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  list: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '0',
    '&:last-child': {
      borderBottom: '0px solid transparent',
    },
  },
  card_header: {
    fontSize: '1.2rem',
  },
  title_back: {
    color: theme.texts.module_title,
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.3rem',
    },
  },
  wrapper: {
    boxSizing: 'border-box',
    padding: '15px',
  },
});

const mapStateToProps = (state) => {
  return {
    preguntas: state.preguntasKnowledgeBase,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    soporteObtenerPreguntasKnowledgeBase: (callback) =>
      dispatch(soporteObtenerPreguntasKnowledgeBase(callback)),
  };
};

export const ArticuloDetail = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(ArticuloDetail_)
);
